import React, { ReactNode } from 'react';
import styled from 'styled-components';

const LabelElementSt = {
  Wrap: styled.div`
    display: flex;
    align-items: center;
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  `,
  Label: styled.label<{ $labelWidth: number }>`
    color: #192640;
    font-size: 16px;
    font-weight: 600;
    min-width: ${(p) => p.$labelWidth + 'px'};
  `,
};

interface LabelElementProps {
  $labelWidth?: number;
  children: ReactNode;
  id?: string;
  label: string;
}

const LabelElement = ({ $labelWidth = 85, children, id, label }: LabelElementProps) => {
  return (
    <LabelElementSt.Wrap>
      <LabelElementSt.Label $labelWidth={$labelWidth} htmlFor={id}>
        {label}
      </LabelElementSt.Label>
      {children}
    </LabelElementSt.Wrap>
  );
};

export default LabelElement;
